import { v4 as uuid } from 'uuid';
import { DraggableLocation } from 'react-beautiful-dnd';
import { LocationStable } from '../../../models/locations';
import { TaskLibraryListType } from '../../../models/common';
import {
  HealthSystemDomainTaskLibraryResultTaskScheduleViewModel,
  HealthSystemDomainTaskLibraryResultTaskTemplateViewModel
} from '../../../api/HealthSystemApi';

export const reorderTaskList = (
  source: HealthSystemDomainTaskLibraryResultTaskScheduleViewModel,
  startIndex: number,
  endIndex: number
): HealthSystemDomainTaskLibraryResultTaskScheduleViewModel => {
  const result = Array.from(source.taskItems);
  const [removed] = result.splice(startIndex, 1);

  result.splice(endIndex, 0, removed);

  return {
    ...source,
    taskItems: result
  };
};

export const copyTaskList = (
  source: HealthSystemDomainTaskLibraryResultTaskTemplateViewModel[],
  destination: HealthSystemDomainTaskLibraryResultTaskScheduleViewModel,
  droppableSource: DraggableLocation,
  droppableDestination: DraggableLocation,
  selectedLocationStable: LocationStable
): HealthSystemDomainTaskLibraryResultTaskScheduleViewModel => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination.taskItems);
  const item = sourceClone[droppableSource.index];

  if (item.type === TaskLibraryListType.TaskLibrary) {
    destClone.splice(droppableDestination.index, 0, {
      ...item,
      id: uuid(),
      taskLibraryId: item.id,
      vaccinationRuleId: null
    });
  }

  if (item.type === TaskLibraryListType.VaccinationRule) {
    destClone.splice(droppableDestination.index, 0, {
      ...item,
      id: uuid(),
      taskLibraryId: null,
      vaccinationRuleId: item.id
    });
  }

  return {
    ...destination,
    taskItems: destClone,
    stable: selectedLocationStable
  };
};

export const moveTaskList = (
  source: HealthSystemDomainTaskLibraryResultTaskScheduleViewModel,
  destination: HealthSystemDomainTaskLibraryResultTaskScheduleViewModel,
  droppableSource: DraggableLocation,
  droppableDestination: DraggableLocation
): Record<string, HealthSystemDomainTaskLibraryResultTaskScheduleViewModel> => {
  const sourceClone = Array.from(source.taskItems);
  const destClone = Array.from(destination.taskItems);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  // Both lanes keep everything but their tasks. The save writes each lane's week cycle and start of
  // working day as sent, so a lane that lost them would move to cycle 0 and drop out of the planning.
  return {
    [droppableSource.droppableId]: { ...source, taskItems: sourceClone },
    [droppableDestination.droppableId]: { ...destination, taskItems: destClone }
  };
};

export const removeTaskList = (
  source: HealthSystemDomainTaskLibraryResultTaskScheduleViewModel,
  droppableSource: { index: number }
): HealthSystemDomainTaskLibraryResultTaskScheduleViewModel => {
  const sourceClone = Array.from(source.taskItems);
  sourceClone.splice(droppableSource.index, 1);

  return {
    ...source,
    taskItems: sourceClone
  };
};
